import { SiteRolesPickerCtrl } from '../controllers/SiteRolesPickerCtrl';
import { Module } from '../Module';

Module.instance().directive('tbSiteRolesPicker', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'siteRolesPicker.html',
      controller: SiteRolesPickerCtrl,
      scope: {
        usersWithSiteRoles: '=?',
        changes: '=',
        busy: '=?'
      }
    };
  }
]);
